import Box from '@mui/material/Box';

import { Layout } from '@/components/Layout/Layout';
import { OpenDataCommercial } from '@/components/Logo/OpenDataCommercial';
import { MainSearchBar } from '@/components/MainSearchBar/MainSearchBar';

import { landingPageStyles as sx } from './LandingPage.styles';

export const LandingPage = () => {
	return (
		<Layout displayLogo={false} displaySearchBar={false} fullHeightMainContent>
			<Box sx={sx.root}>
				<OpenDataCommercial sx={sx.appLogo} />
				<MainSearchBar fullWidth fullHeight />
			</Box>
		</Layout>
	);
};
